// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9561f9b8","540":"e9542dfb","812":"b10ea4af"}[chunkId] + ".chunk.js";
};